import React from "react";
import { FaReceipt } from "react-icons/fa";

const CheckoutPriceDetails = ({
  subtotal = 0,
  taxAmount = 0,
  deliveryFee = 0,
  totalAmount = 0,
  walletDiscount = 0,
  couponDiscount = 0,
  couponCode = '',
}) => {
  return (
    <div className="rounded-xl border border-gray-200 bg-white p-4 shadow-sm">
      <div className="flex items-center gap-2 mb-3 pb-2 border-b border-gray-100">
        <FaReceipt className="h-5 w-5 text-[#046a38]" />
        <h2 className="text-base font-bold text-gray-900">Price Details</h2>
      </div>

      <div className="space-y-2 text-xs sm:text-sm text-gray-700">
        <div className="flex justify-between">
          <span>Subtotal</span>
          <span className="font-semibold text-gray-900">
            ₹{Number(subtotal).toFixed(2)}
          </span>
        </div>

        <div className="flex justify-between">
          <span>GST / Tax Amount</span>
          <span className="font-semibold text-gray-900">
            ₹{Number(taxAmount).toFixed(2)}
          </span>
        </div>

        <div className="flex justify-between">
          <span>Delivery Fee</span>
          <span
            className={`font-semibold ${
              Number(deliveryFee) === 0 ? "text-[#046a38]" : "text-gray-900"
            }`}
          >
            {Number(deliveryFee) === 0 ? "FREE" : `₹${Number(deliveryFee).toFixed(2)}`}
          </span>
        </div>

        {Number(couponDiscount) > 0 && (
          <div className="flex justify-between font-semibold text-[#046a38]">
            <span>Coupon savings{couponCode ? ` (${couponCode})` : ''}</span>
            <span>− ₹{Number(couponDiscount).toFixed(2)}</span>
          </div>
        )}

        {Number(walletDiscount) > 0 && (
          <div className="flex justify-between text-[#046a38]">
            <span className="flex items-center gap-1.5">
              <span>👛</span>
              Wallet Credit Applied
            </span>
            <span className="font-semibold">− ₹{Number(walletDiscount).toFixed(2)}</span>
          </div>
        )}

        <div className="pt-2 border-t border-gray-100 flex justify-between items-center text-sm sm:text-base font-bold text-gray-900">
          <span>Total Payable (Incl. of all taxes)</span>
          <span className="text-[#046a38] text-lg sm:text-xl">
            ₹{Number(totalAmount).toFixed(2)}
          </span>
        </div>
      </div>
    </div>
  );
};

export default CheckoutPriceDetails;
